import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import SidebarLayout from '../../components/layout/SidebarLayout';
import { CardViewContent } from './CardViewPage';

/* ── Single card cell — full CardViewContent in a scrollable white card ── */
const CardCell = ({ cardId, saleId }) => (
  <div className="bg-white rounded-lg border shadow-sm flex flex-col overflow-hidden" data-testid={`card-cell-${cardId}`}>
    <div className="flex-1 overflow-y-auto p-4">
      <CardViewContent
        cardId={cardId}
        saleId={saleId}
        viewOnly={false}
        showBackButton={false}
        shouldRun={true}
      />
    </div>
  </div>
);

/* ── Main multi-card runner page ── */
export default function MultiCardRunnerPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cardIds = [], saleId, saleName } = location.state || {};

  if (!cardIds.length) {
    return (
      <SidebarLayout>
        <div className="flex flex-col items-center justify-center gap-4 py-24">
          <p className="text-muted-foreground">No cards selected.</p>
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-2" /> Go Back
          </Button>
        </div>
      </SidebarLayout>
    );
  }

  return (
    <SidebarLayout>
      <div className="flex flex-col min-h-full">
        {/* Top bar */}
        <div className="flex items-center gap-3 mb-4">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="gap-1">
            <ArrowLeft className="w-4 h-4" /> Back
          </Button>
          <div>
            <p className="font-semibold text-sm leading-tight">Running {cardIds.length} Cards</p>
            {saleName && <p className="text-xs text-muted-foreground">{saleName}</p>}
          </div>
        </div>

        {/* Grid: 2 columns desktop, 1 column mobile */}
        <div className="multi-card-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
          {cardIds.slice(0, 4).map(id => (
            <CardCell key={id} cardId={id} saleId={saleId} />
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .multi-card-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </SidebarLayout>
  );
}
